














































































import { Component, Ref, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import { NewPriceWings, SelectWings } from "wings-ui-components";
import { notifyError, notifySuccess } from "@/utils/notify-helper";
import { BalanceItem, BalanceItemImpl } from "@/store/finance/types";
import { PartnerItem } from "@/store/settings/partners/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import axios from "axios";
import {ActionLog} from "@/store/auth/types";

@Component({ components: { NewPriceWings, SelectWings } })
export default class TopUpBalance extends Vue {

  @Ref("validator") validator: any;

  @Action("putBalance") actionSave: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("actionLog") actionLog: any;

  private partnerId: number | null = null;
  private item: BalanceItem = new BalanceItemImpl();
  partnersList: PartnerItem[] = [];
  private logObject: ActionLog = {};

  filterKeys: object = {
    "description" : "commentary"
  }

  back(): void {
    this.$router.push(`/finances/overdrafts`);
  }

  async getPartnersList(filter: any) {
    const partners = await this.actionGetPartners(filter);
    this.partnersList = partners.filter((e:any) => e.prepaid === true);
  }

  async onTopUp(): Promise<void> {
    let valid: boolean = await this.validator.validate();
    if (valid) {
      this.item.source = <string> this.$t('administrator');
      try {
        let object = {
          id: this.partnerId,
          item: this.item,
        };
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Balance top-up",
          action_status: "success",
          object_type: "Balance",
          addititional_info: getTranslatedParams(this.item, this.filterKeys)
        };
        await this.actionSave(object);
        await this.actionLog(this.logObject);
        this.back();
        notifySuccess(<string> this.$t('balance_completed'));
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors);
      }, 100);
    }
  }
}
